//base_url
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const RELATIVE_URL = process.env.REACT_APP_RELATIVE_URL;
export const HOST = process.env.REACT_APP_HOST;
export const VISION_IMPAIRED = "VISION_IMPAIRED";
export const FONT_SIZE_CHANGED = "FONT_SIZE_CHANGED";
export const SET_HOST = "SET_HOST"



//auth reducers
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

export const UPDATE_OIB = "UPDATE_OIB";

export const AUTHORITIES = "AUTHORITIES";

//form fetch reducers
export const FETCH_FORM_REQUEST = "FETCH_FORM_REQUEST";
export const FETCH_FORM_SUCCESS = "FETCH_FORM_SUCCESS";
export const FETCH_FORM_FAILURE = "FECH_FORM_FAILURE";

//reqUUIDdokumenta
export const DOCUMENT_UUID = "DOCUMENT_UUID";
export const FORM_SUBMIT_SUCCESS = "FORM_SUBMIT_SUCCESS";
export const FORM_SUBMIT_ERROR = "FORM_SUBMIT_ERROR";
export const DOCUMENT_PURGE = "DOCUMENT_PURGE";

//podaci za azuriranje osoba/drustvo

export const GET_DRUSTVO = "GET_DRUSTVO";
export const GET_OSOBA = "GET_OSOBA";
export const PURGE_UPDATE = "PURGE_UPDATE";

export const POLICE_OSIGURANJA_INITIAL_STATE = {
  nazivRevDrustva: "",
  oib: "",
  registarskiBroj: "",
  brojPolice: "",
  premijaZaRazdoblje: "",
  svotaPokrica: "",
  datumIstekaPolice: "",
  obavijestONastalimPromjenama: [],
  dokumentPoliceOsiguranja: [],
  napomena: "",
  obrisaniDokumenti: [],
};

export const IZVJESCA_INITIAL_STATE = {
  nazivRevDrustva: "",
  oib: "",
  registarskiBroj: "",
  godina: "",
  datumObjaveIzvjesca: "",
  webStranicaObjaveIzv: "",
  rokObjave: "",
  azuriranaVerzija: false,
  webStranicaObjaveAzurIzv: "",
  datObjaveAzurVerIzv: "",
  datObavNadleznogTijela: "",
  obavijestOIznimci: [],
  datObavijestiOIznimci: "",
  dokumenti: [],
  obrisaniDokumenti: [],

  napomena: "",
};

export const UGOVOR_SJI_INITIAL_STATE = {
  nazivRevDrustva: "",
  oib: "",
  registarskiBroj: "",
  datSklapanjaUgovora: "",
  brojUgovora: "",
  predmetUgovora: "",
  ugovaratelj: "",
  zajRevizija: "",
  dokumenti: [],
  obrisaniDokumenti: [],

  napomena: "",
};

export const RASKID_UGOVORA_INITIAL_STATE = {
  nazivRevDrustva: "",
  oib: "",
  registarskiBroj: "",
  datRaskidaUgovora: "",
  brojUgovora: "",
  predmetUgovora: "",
  ugovaratelj: "",
  dokumenti: [],
  obrisaniDokumenti: [],
  napomena: "",
};

export const REVIDIRANI_SJI_INITIAL_STATE = {
  revidiraniSubjekt: "",
  nazivRevDrustva: "",
  oib: "",
  registarskiBroj: "",
  datObavijesti: "",
  zaGodinu: "",
  prihodiOdRevizije: "",
  prihodiKojeZahtjevaZakonodavstvo: "",
  prihodiKojeNeZahtjevaZakonodavstvo: "",
  dokumenti: "",
  obrisaniDokumenti: [],
  napomena: "",
};

export const FORM_SUBMIT_URL = {
  1: "/posebne-evidencije/polica-osiguranja",
  2: "/posebne-evidencije/izvjesce-o-transparentnosti",
  3: "/posebne-evidencije/ugovor-o-reviziji-sji",
  4: "/posebne-evidencije/raskid-ugovora",
  5: "/posebne-evidencije/revidirani-sji",
};

export const VERSION = process.env.REACT_APP_VERSION;
export const PKI_PROTOCOL = process.env.REACT_APP_PKI_PROTOCOL;

export const YEAR_PLAN_TYPE={
  main:"MAIN_YEAR_PLAN",
  additional:"INDIVIDUAL_ADDITIONAL_PLAN",
}

export const ACTIVITY_TYPE={
  1:"A -  Specifikacija osnovnih aktivnosti stalnog stručnog usavršavanja iz članka 7. stavka 1. točke 1. Pravilnika",
  2:"B - Specifikacija osnovnih aktivnosti stalnog stručnog usavršavanja iz članka 7. stavka 1. točke 2. do 5. Pravilnika",
  3:"C - Specifikacija ostalih aktivnosti stalnog stručnog usavršavanja iz članka 7. stavka 2. točke 1. i 2. Pravilnika"
}

export const EDU_STATEMENTS = {
  1:"Izjavljujem da se aktivnosti prenose internetom u realnom vremenu te omogućuju interakciju predavača i sudionika putem video, audio i tekstualne komunikacije.",
  2:"Izjavljujem da su za navedene aktivnosti uspostavljeni odgovarajući i provjerljivi mehanizmi prijave sudionika i kontrole njihova prisustva i/ili znanja tijekom održavanja aktivnosti i navođenje istih."
};

export const EDU_FORMAT_TYPES = {
  WEBINAR: "webinar",
  LIVE: "uživo"
}